import { ActionIcon, Box, Button, Center, CloseButton, Divider, Flex, LoadingOverlay, Text } from "@mantine/core";
import { WarningIcon } from "@phosphor-icons/react";
import React from "react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { ConfirmNote, nextStepToast } from "@dehub/theme";
import { OrderApi } from "../../apis";
import HttpHandler from "../../utils/http-handler";
import { message } from "../../utils/message";
import { FormLayout } from "../layout";

type Props = {
  action?: any;
  setActions?: any;
  constant?: any;
  reload?: any;
  respond?: any;
};

export function BuyerSalesDynamicConfirmForm({ action, setActions, constant, reload, respond }: Props) {
  const navigate = useNavigate();
  const { t } = useTranslation(["order", "common"]);
  const [loading, setLoading] = React.useState<boolean>(false);

  const onSubmit = async (value: string) => {
    setLoading(true);
    try {
      switch (value) {
        case "REJECT": {
          await OrderApi.respond(action?.id, {
            approve: false,
          });
          setActions([]);
          nextStepToast("order.buyer-sales-detail.toast.reject", { fallback: { title: t("order:buyerSales.confirmRejectedSuccess") } });
          if (respond !== "respond") {
            reload();
          } else {
            navigate("/buyer-sales");
          }
          break;
        }
        case "CONFIRM": {
          await OrderApi.respond(action?.id, {
            approve: true,
          });
          setActions([]);
          nextStepToast("order.buyer-sales-detail.toast.approve", { fallback: { title: t("order:buyerSales.confirmApprovedSuccess") } });
          if (respond !== "respond") {
            reload();
          } else {
            navigate("/buyer-sales");
          }
          break;
        }
      }
    } catch (err) {
      message.error((err as HttpHandler)?.message!);
    }
    setLoading(false);
  };

  return (
    <Box mt={20}>
      <FormLayout
        title={t("order:buyerSales.approveOrder")}
        subTitle={`${t("order:buyerSales.contractOrderAction")} ${constant !== "reject" ? t("common:actions.approve") : t("common:actions.reject")}`}
        extra={[<CloseButton key="cancel" onClick={() => setActions([])} />]}>
        <LoadingOverlay visible={loading} />
        <Divider color="gray" my="xs" />
        <Flex style={{ position: "relative" }} direction="column" gap="md">
          <Center>
            <ActionIcon size={100} radius={100} variant="light" color="yellow">
              <WarningIcon size="4.125rem" />
            </ActionIcon>
          </Center>
          <Center>
            <Text fw={500} fz={24} c="gray.7">
              {constant !== "reject" ? t("order:buyerSales.approveConfirmQuestion") : t("order:buyerSales.rejectConfirmQuestion")}
            </Text>
          </Center>
          <Center>
            <Text w={"540px"} ta="center" c="gray.8" fz={18}>
              {t("order:buyerSales.approveConfirmDescription")}
            </Text>
          </Center>
          {/* @dehub/help «дараа нь» line (10 §2.13): what happens after approving / rejecting. */}
          <Box px="md">
            <ConfirmNote helpKey={constant === "reject" ? "order.buyer-sales-detail.confirm.reject" : "order.buyer-sales-detail.confirm.approve"} mt={0} />
          </Box>

          <Divider color="gray" mt={20} />
          <Flex direction="row" justify="space-between" mb={15}>
            <Button variant="outline" onClick={() => setActions([])}>
              {t("common:actions.cancel")}
            </Button>
            <Flex gap="md">
              {constant === "reject" && (
                <Button
                  variant="light"
                  color="red"
                  onClick={() => {
                    onSubmit("REJECT");
                  }}>
                  {t("common:actions.reject")}
                </Button>
              )}
              {constant === "confirm" && (
                <Button
                  variant="filled"
                  onClick={() => {
                    onSubmit("CONFIRM");
                  }}>
                  {t("common:actions.approve")}
                </Button>
              )}

              {constant !== "reject" && constant !== "confirm" && (
                <>
                  <Button
                    variant="light"
                    color="red"
                    onClick={() => {
                      onSubmit("REJECT");
                    }}>
                    {t("common:actions.reject")}
                  </Button>
                  <Button
                    variant="filled"
                    onClick={() => {
                      onSubmit("CONFIRM");
                    }}>
                    {t("common:actions.approve")}
                  </Button>
                </>
              )}
            </Flex>
          </Flex>
        </Flex>
      </FormLayout>
    </Box>
  );
}
